import React, { useState, useMemo } from 'react';
import { Grid, Tooltip } from '@material-ui/core';
import BreadCrumbs from '../../../../Core/Controls/Breadcrumb';
import ReportGijgoGrid from '../../../internal/ReportsScreens/GijgoForReportsScreen';
import { SquareButton } from '../../../../Core/FormInput/AppButton';
import { Add } from '@material-ui/icons';
import EditIcon from '@material-ui/icons/Edit';
import ReactDOM from 'react-dom';
import DialogComp from '../../../../Core/Modal/dialogModal';
import AddUpdateWorkTypes from './addUpdateWorkTypes';

let styleObj = {
    backgroundColor: '#183B68',
    borderRadius: '20%',
    width: '32px',
    height: '32px',
    textAlign: 'center',
    padding: '0px 0px 0px 0px'
};

const crumbs = [
    { name: 'Home', path: '/' },
    { name: 'Work Types', path: '/', active: true }
];

const TCardWorkTypes = () => {
    const [state, setState] = useState({
        isReload: new Date(),
        showModal: false,
        selectedWorkTypeID: null
    });
    const handleClose = (shouldReload) => {
        setState((st) => ({
            ...st,
            showModal: false,
            selectedWorkTypeID: null,
            isReload: shouldReload ? new Date() : st.isReload
        }));
    };

    const baseColumns = [
        {
            field: 'action',
            title: `Action`,
            filterable: false,
            sortable: false,
            width: '3%'
        },
        {
            field: 'tCardWorkTypeDescription',
            title: `Description`,
            filterable: true,
            sortable: true,
            width: '10%'
        },
        {
            field: 'tcardEventType',
            title: `Event Type`,
            filterable: true,
            sortable: true,
            width: '10%'
        },
        {
            field: 'tCardWorkTypeCause',
            title: `Cause`,
            filterable: true,
            sortable: true,
            width: '10%'
        },
        {
            field: 'tCardWorkTypeCure',
            title: `Cure`,
            filterable: true,
            sortable: true,
            width: '10%'
        },
        {
            field: 'tCardWorkTypeAllocatedHours',
            title: `Allocated Hours`,
            filterable: true,
            sortable: true,
            width: '10%'
        },
        {
            field: 'tCardWorkTypeDisplayTimer',
            title: `Display Timer`,
            filterable: true,
            sortable: true,
            width: '10%'
        },
        {
            field: 'tCardWorkTypeSequence',
            title: `Display Sequence`,
            filterable: true,
            sortable: true,
            width: '10%'
        }
    ];

    const handelAddUpdate = (row = null) => {
        setState((st) => ({
            ...st,
            showModal: true,
            selectedWorkTypeID: row ? row.tCardWorkTypeID : null
        }));
    };
    const addButton = () => {
        const spn = document.createElement('span');
        const lnk = (
            <Grid container justifyContent="center" style={{ marginLeft: '5px' }}>
                <Tooltip title="Add Work Type" arrow>
                    <abbr style={{ textDecoration: 'none' }}>
                        <SquareButton style={styleObj} onClick={() => handelAddUpdate(null)}>
                            <Add fontSize="small" style={{ color: 'white' }} />
                        </SquareButton>
                    </abbr>
                </Tooltip>
            </Grid>
        );
        ReactDOM.render(lnk, spn);
        return spn;
    };

    const editButton = () => (value, record) => {
        const spn = document.createElement('span');
        const lnk = (
            <Grid container justifyContent="space-evenly">
                <Tooltip title="Edit Work Type" arrow>
                    <abbr style={{ textDecoration: 'none' }}>
                        <SquareButton style={styleObj} onClick={() => handelAddUpdate(record)}>
                            <EditIcon fontSize="small" style={{ color: 'white' }} />
                        </SquareButton>
                    </abbr>
                </Tooltip>
            </Grid>
        );
        ReactDOM.render(lnk, spn);
        return spn;
    };

    const columns = useMemo(() => {
        const tempCols = [...baseColumns];
        let actionCol = tempCols.find((element) => element.field === 'action');

        if (actionCol) {
            actionCol.renderer = editButton({});
        }

        return tempCols;
    }, []);
    const rowDataStyle = (record) => {
        return {
            ['background-color']: record.tcardWorkTypeBackColour || 'white'
        };
    };
    const colDataStyle = (record) => {
        return {
            ['color']: record.tcardWorkTypeTextColour || 'black'
        };
    };

    const baseUrl = 'TCardWorkTypes/TCardWorkType_list';

    return (
        <div>
            <BreadCrumbs crumbs={crumbs} />
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <ReportGijgoGrid
                        dataConverter={(res) => ({
                            records: res?.data,
                            total: res?.data[0]?.total
                        })}
                        columns={columns}
                        getUrl={baseUrl}
                        isReload={state.isReload}
                        AddBtn={addButton}
                        setRowStyleOnCondition={true}
                        setRowStyleFunction={rowDataStyle}
                        setColStyleOnCondition={true}
                        setColStyleFunction={colDataStyle}
                    />
                </Grid>
            </Grid>
            {state.showModal ? (
                <DialogComp overflow="auto" title={state.selectedWorkTypeID ? 'Update Work Type' : 'Add Work Type'} maxWidth="md" onClose={() => handleClose(false)}>
                    <AddUpdateWorkTypes width="lg" onClose={() => handleClose(true)} workTypeID={state.selectedWorkTypeID} />
                </DialogComp>
            ) : null}
        </div>
    );
};
export default TCardWorkTypes;
